import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Button, Spinner } from '@salesforce/design-system-react';

import './ContingencyImageCard.scss';

class ContingencyImageCard extends Component {
  constructor(props) {
    super(props);
    this.inputFileRef = React.createRef();
  }

  handleFileSelect(event) {
    const file =
      event.target.files && event.target.files.length && event.target.files[0];
    if (file) {
      const payload = new FormData();
      payload.append('contingency_image', file, file.name);
      this.props.actions.saveContingencyImage(payload, {
        cToken: this.props.session.cToken
      });
    }
  }

  renderImage() {
    const { formatMessage } = this.props.intl;

    let content;
    if (!this.props.contingencyImage) {
      content = (
        <div className="button-container">
          <Button
            iconCategory="utility"
            iconName="upload"
            iconPosition="left"
            label={formatMessage({
              id: 'components.ecs.fallback.uploadImage'
            })}
            onClick={() => this.inputFileRef.current.click()}
          />
        </div>
      );
    } else {
      const style = { backgroundImage: `url(${this.props.contingencyImage})` };
      content = <div className="bg-img" style={style} />;
    }

    const isSaving = false;
    return (
      <div className="card-img">
        {content}
        {isSaving ? (
          <div className="spinner">
            <Spinner variant="brand" />
          </div>
        ) : null}
      </div>
    );
  }

  footer() {
    const { formatMessage } = this.props.intl;
    if (this.props.contingencyImage) {
      return (
        <div className="card-footer">
          <Button
            className="replace-button"
            label={formatMessage({
              id: 'components.ecs.fallback.replace'
            })}
            onClick={() => this.inputFileRef.current.click()}
          />
        </div>
      );
    }
    return null;
  }

  render() {
    const classNames = this.props.contingencyImage ? 'card' : 'card empty';
    return (
      <div className={classNames}>
        {this.renderImage()}
        {this.footer()}
        <input
          type="file"
          id="open-file-input"
          ref={this.inputFileRef}
          style={{ display: 'none' }}
          onChange={this.handleFileSelect.bind(this)}
          onClick={event => {
            event.target.value = null;
          }}
        />
      </div>
    );
  }
}

ContingencyImageCard.propTypes = {
  actions: PropTypes.object,
  contingencyImage: PropTypes.string,
  location: PropTypes.object,
  session: PropTypes.object
};

export default injectIntl(ContingencyImageCard);
